import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'

Vue.use(Router)

function loadRoute (component) {
  return () => import(`../components/routes/${component}.vue`)
}

const router = new Router({
// export default new Router({
  mode: 'history',
  /*
   * NOTE! VueRouter "history" mode DOESN'T works for Cordova builds,
   * it is only to be used only for websites.
   *
   * If you decide to go with "history" mode, please also open /config/index.js
   * and set "build.publicPath" to something other than an empty string.
   * Example: '/' instead of current ''
   *
   * If switching back to default "hash" mode, don't forget to set the
   * build publicPath back to '' so Cordova builds work again.
   */
  routes: [
    {
      path: '/',
      name: 'home',
      ja: 'ホーム',
      component: loadRoute('Home'),
      icon: 'home',
      color: '#BF4A67'

    },
    {
      path: '/admin',
      name: 'admin',
      ja: '管理者専用',
      meta: {requiresAuth: true},
      component: loadRoute('Admin')
    },
    {
      path: '/posts',
      name: 'posts',
      ja: '投稿一覧',
      component: loadRoute('Posts'),
      meta: {requiresAuth: true},
      icon: 'edit',
      color: '#178CA6'
    },
    {
      path: '/posts/:id(\\d+)',
      name: 'post',
      ja: '投稿編集',
      component: loadRoute('Post'),
      props: true,
      meta: {requiresAuth: true}
    },
    {
      path: '/pages',
      name: 'pages',
      ja: '固定ページ一覧',
      component: loadRoute('Pages'),
      meta: {requiresAuth: true},
      icon: 'files-o',
      color: '#368F7D'
    },
    {
      path: '/pages/create',
      name: 'pages-create',
      ja: '固定ページ作成',
      component: loadRoute('PagesCreate'),
      meta: {requiresAuth: true}
    },
    {
      path: '/pages/:id(\\d+)',
      name: 'page',
      ja: '固定ページ編集',
      component: loadRoute('Page'),
      props: true,
      meta: {requiresAuth: true}
    },
    {
      path: '/media',
      name: 'media',
      ja: 'アップロード画像',
      component: loadRoute('Media'),
      meta: {requiresAuth: true},
      icon: 'image',
      color: '#EE7469'
    },
    {
      path: '/media/upload',
      name: 'media-upload',
      ja: '画像アップロード',
      component: loadRoute('MediaUpload'),
      meta: {requiresAuth: true}
    },
    {
      path: '/themes',
      name: 'themes',
      ja: 'サイトテーマ',
      component: loadRoute('Themes'),
      meta: {requiresAuth: true},
      icon: 'columns',
      // color: '#00587A'
      color: '#4c8aa1'
    },
    {
      path: '/settings',
      name: 'settings',
      ja: 'サイト設定',
      component: loadRoute('Settings'),
      meta: {requiresAuth: true},
      icon: 'gear',
      color: '#44B39D'
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
})

router.beforeEach(async (to, from, next) => {
  // /**
  //  * ページを表示する前にsettingsを取得しておく
  //  */
  // // if (to.matched.some(record => ~['page', 'settings', 'themes'].indexOf(record.name))) {
  // if (~['page', 'themes', 'settings'].indexOf(to.name)) {
  //   if (process.env.NODE_ENV !== 'production') console.log('Get settings before entering route...')
  //   await store.dispatch('wordpress/getSettings')
  // }
  //
  // /**
  //  * ページを表示する前にthemesを取得しておく
  //  */
  // // if (to.matched.some(record => ~['page', 'themes'].indexOf(record.name))) {
  // if (~['page', 'themes'].indexOf(to.name)) {
  //   if (process.env.NODE_ENV !== 'production') console.log('Get themes before entering route...')
  //   await store.dispatch('wordpress/getThemes')
  // }
  //
  // /**
  //  * ページを表示する前にpagesを取得しておく
  //  */
  // // if (to.matched.some(record => ~['pages', 'pages-tree'].indexOf(record.name))) {
  // if (~['pages', 'page', 'themes'].indexOf(to.name)) {
  //   if (process.env.NODE_ENV !== 'production') console.log('Get pages before entering route...')
  //   if (!store.getters['wordpress/pages'].length) await store.dispatch('wordpress/getPages')
  // }
  //
  // /**
  //  * ページを表示する前にmediaを取得しておく
  //  */
  // // if (to.matched.some(record => ~['settings', 'images'].indexOf(record.name))) {
  // if (~['images', 'page', 'themes', 'settings'].indexOf(to.name)) {
  //   if (process.env.NODE_ENV !== 'production') console.log('Get media before entering route...')
  //   if (!store.getters['wordpress/media'].length) await store.dispatch('wordpress/getMedia')
  // }

  let isLoggedIn = store.getters['wordpress/account/isLoggedIn']
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!isLoggedIn) {
      store.dispatch('wordpress/account/logout')
      next({path: '/', query: {redirect: to.fullPath}})
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js